var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.04,
    height: 48.04,
    viewBox: "0 0 48.04 48.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0561fc;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 70.77,
    cy: 73.34,
    r: 24.02,
    transform: "translate(-77.89 22.2) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M67.14,70.07a2.48,2.48,0,0,1,1.74.49,2.12,2.12,0,0,1,.51,1.59,6.55,6.55,0,0,1-.12,1.18c-.08.39-.18.82-.3,1.28l-1.3,4.6a12.53,12.53,0,0,0-.24,1.23,7.68,7.68,0,0,0-.08,1.06,2.48,2.48,0,0,0,.88,2,3.87,3.87,0,0,0,2.6.79,6.23,6.23,0,0,0,2-.29c.55-.2,1.3-.48,2.22-.84l.07-.27h0a4.6,4.6,0,0,1-1.2.18,2.73,2.73,0,0,1-1.74-.44A2,2,0,0,1,71.56,81a7,7,0,0,1,.13-1.15,13.21,13.21,0,0,1,.3-1.32l1.29-4.57a7.14,7.14,0,0,0,.25-1.3c0-.6.06-.88.06-1a2.49,2.49,0,0,0-.84-2,3.73,3.73,0,0,0-2.56-.78,6.84,6.84,0,0,0-2,.35c-.69.22-1.42.48-2.17.78l-.07.28.06,0A4.08,4.08,0,0,1,67.14,70.07Z",
    transform: "translate(-46.75 -49.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M73.07,62.44a2.6,2.6,0,0,0-1.85.71,2.21,2.21,0,0,0-.75,1.68,2.17,2.17,0,0,0,.75,1.66,2.6,2.6,0,0,0,1.85.71,2.55,2.55,0,0,0,1.83-.71,2.16,2.16,0,0,0,.74-1.66,2.2,2.2,0,0,0-.74-1.68A2.55,2.55,0,0,0,73.07,62.44Z",
    transform: "translate(-46.75 -49.32)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info_icon.7bdb2c8886d1d0de9a5437bc11f96062.svg";
export { ForwardRef as ReactComponent };